<template>
  <div class="grid-view approval-list-grid">
    <div class="main-content">
      <div class="section grid-wrapper">
        <!--        <cargo-ag-grid-->
        <!--          :config-module="configModule"-->
        <!--          :grid-params.sync="gridParams"-->
        <!--          :grid-options="gridOptions"-->
        <!--          :column-defs="columnDefs"-->
        <!--          :row-data="rowData"-->
        <!--        />-->
        <!--我发起的/我处理的-->
        <cargo-ag-grid
          v-if="documentConfigIdProp===0"
          :config-module="type===WORKFLOW_TYPE_LOOK ? '33000101' : '44000101'"
          :per-config-name="perConfigName"
          :refresh-id="gridRefreshId"
          :grid-params.sync="initiateGrid.gridParams"
          :grid-options="initiateGrid.gridOptions"
          :column-defs="type===WORKFLOW_TYPE_LOOK ? [...initiateGrid.columnDefs] : [...initiateGrid.columnDefs, attachColumn]"
          :row-data="rowData"
        />
        <!--我发起的/我处理的-付款申请单-->
        <cargo-ag-grid
          v-if="documentConfigIdProp===BILL_PAYMENT"
          :config-module="type===WORKFLOW_TYPE_LOOK ? '33000202' : '44000202'"
          :per-config-name="perConfigName"
          :refresh-id="gridRefreshId"
          :grid-params.sync="billPaymentGrid.gridParams"
          :grid-options="billPaymentGrid.gridOptions"
          :column-defs="type===WORKFLOW_TYPE_LOOK ? [...billPaymentGrid.columnDefs] : [...billPaymentGrid.columnDefs, attachColumn]"
          :row-data="rowData"
        />
        <!--我发起的/我处理的-开票申请单-->
        <cargo-ag-grid
          v-if="documentConfigIdProp===MAKE_INVOICE"
          :config-module="type===WORKFLOW_TYPE_LOOK ? '33000303' : '44000303'"
          :per-config-name="perConfigName"
          :refresh-id="gridRefreshId"
          :grid-params.sync="makeInvoiceGrid.gridParams"
          :grid-options="makeInvoiceGrid.gridOptions"
          :column-defs="type===WORKFLOW_TYPE_LOOK ? [...makeInvoiceGrid.columnDefs] : [...makeInvoiceGrid.columnDefs, attachColumn]"
          :row-data="rowData"
        />
        <!--我发起的/我处理的-业务费用申请单-->
        <cargo-ag-grid
          v-if="documentConfigIdProp===Job_CHARGE"
          :config-module="type===WORKFLOW_TYPE_LOOK ? '33000404' : '44000404'"
          :per-config-name="perConfigName"
          :refresh-id="gridRefreshId"
          :grid-params.sync="jobChargeGrid.gridParams"
          :grid-options="jobChargeGrid.gridOptions"
          :column-defs="type===WORKFLOW_TYPE_LOOK ? [...jobChargeGrid.columnDefs] : [...jobChargeGrid.columnDefs, attachColumn]"
          :row-data="rowData"
        />
        <!--我发起的/我处理的-费用更改申请单-->
        <cargo-ag-grid
          v-if="documentConfigIdProp===CHARGE_CHANGE"
          :config-module="type===WORKFLOW_TYPE_LOOK ? '33000606' : '44000606'"
          :per-config-name="perConfigName"
          :refresh-id="gridRefreshId"
          :grid-params.sync="chargeChangeGrid.gridParams"
          :grid-options="chargeChangeGrid.gridOptions"
          :column-defs="type===WORKFLOW_TYPE_LOOK ? [...chargeChangeGrid.columnDefs] : [...chargeChangeGrid.columnDefs, attachColumn]"
          :row-data="rowData"
        />
        <!--我发起的/我处理的-临时信控申请单-->
        <cargo-ag-grid
          v-if="documentConfigIdProp===TEMP_CREDIT"
          :config-module="type===WORKFLOW_TYPE_LOOK ? '33000505' : '44000505'"
          :per-config-name="perConfigName"
          :refresh-id="gridRefreshId"
          :grid-params.sync="tempCreditGrid.gridParams"
          :grid-options="tempCreditGrid.gridOptions"
          :column-defs="type===WORKFLOW_TYPE_LOOK ? [...tempCreditGrid.columnDefs] : [...tempCreditGrid.columnDefs, attachColumn]"
          :row-data="rowData"
        />
        <!--我发起的/我处理的-收票申请单-->
        <cargo-ag-grid
          v-if="documentConfigIdProp===COLLECT_INVOICE"
          :config-module="type===WORKFLOW_TYPE_LOOK ? '33000707' : '44000707'"
          :per-config-name="perConfigName"
          :refresh-id="gridRefreshId"
          :grid-params.sync="collectInvoiceGrid.gridParams"
          :grid-options="collectInvoiceGrid.gridOptions"
          :column-defs="type===WORKFLOW_TYPE_LOOK ? [...collectInvoiceGrid.columnDefs] : [...collectInvoiceGrid.columnDefs, attachColumn]"
          :row-data="rowData"
        />
        <!--我发起的/我处理的-合作伙伴-->
        <cargo-ag-grid
          v-if="documentConfigIdProp===PARTNER_APPLICATION_FORM"
          :config-module="type===WORKFLOW_TYPE_LOOK ? '33000808' : '44000808'"
          :per-config-name="perConfigName"
          :refresh-id="gridRefreshId"
          :grid-params.sync="companyGrid.gridParams"
          :grid-options="companyGrid.gridOptions"
          :column-defs="type===WORKFLOW_TYPE_LOOK ? [...companyGrid.columnDefs] : [...companyGrid.columnDefs, attachColumn]"
          :row-data="rowData"
        />
        <!--我发起的/我处理的-合同-->
        <cargo-ag-grid
          v-if="documentConfigIdProp===CONTRACT_APPLICATION_FORM"
          :config-module="type===WORKFLOW_TYPE_LOOK ? '33000909' : '44000909'"
          :per-config-name="perConfigName"
          :refresh-id="gridRefreshId"
          :grid-params.sync="contractGrid.gridParams"
          :grid-options="contractGrid.gridOptions"
          :column-defs="type===WORKFLOW_TYPE_LOOK ? [...contractGrid.columnDefs] : [...contractGrid.columnDefs, attachColumn]"
          :row-data="rowData"
        />
      </div>
    </div>
    <div class="">
      <!--      <cargo-pagination-->
      <!--        :config-module="configModule"-->
      <!--        :total="filter.total"-->
      <!--        :page.sync="filter.pageNum"-->
      <!--        :limit.sync="filter.pageSize"-->
      <!--        @pagination="toQuery"-->
      <!--      />-->
      <!--我发起的/我处理的-->
      <cargo-pagination
        v-if="documentConfigIdProp===0"
        :config-module="type===WORKFLOW_TYPE_LOOK ? '33000101' : '44000101'"
        :total="total"
        :page.sync="filter.pageNum"
        :limit.sync="filter.pageSize"
        @pagination="toQuery"
      />
      <div v-if="documentConfigIdProp===BILL_PAYMENT" style="display: flex;width: 100%;flex-direction: row;justify-content: space-between;">
        <div>
          <!--我发起的/我处理的-付款申请单-->
          <cargo-pagination
            v-if="documentConfigIdProp===BILL_PAYMENT"
            :config-module="type===WORKFLOW_TYPE_LOOK ? '33000202' : '44000202'"
            :total="total"
            :page.sync="filter.pageNum"
            :limit.sync="filter.pageSize"
            @pagination="toQuery"
          />
        </div>
        <div style="display:flex; align-items: center;">
          <span v-text="totalAmountToCurrencyBillPaymentGrid.selectionCountLabel" />
          <charge-currency-total-group
            v-if="reCalc && documentConfigIdProp===BILL_PAYMENT"
            type="both"
            :amount-to-currency="localCurrency"
            data-field="amount"
            :data-provider="totalAmountToCurrencyBillPaymentGrid.dataProvider"
            rate-field="converRate"
            ar-field="ar"
            :show-wht="true"
          />
        </div>
      </div>
      <!--我发起的/我处理的-开票申请单-->
      <cargo-pagination
        v-if="documentConfigIdProp===MAKE_INVOICE"
        :config-module="type===WORKFLOW_TYPE_LOOK ? '33000303' : '44000303'"
        :total="total"
        :page.sync="filter.pageNum"
        :limit.sync="filter.pageSize"
        @pagination="toQuery"
      />
      <!--我发起的/我处理的-业务费用申请单-->
      <cargo-pagination
        v-if="documentConfigIdProp===Job_CHARGE"
        :config-module="type===WORKFLOW_TYPE_LOOK ? '33000404' : '44000404'"
        :total="total"
        :page.sync="filter.pageNum"
        :limit.sync="filter.pageSize"
        @pagination="toQuery"
      />
      <!--我发起的/我处理的-费用更改申请单-->
      <cargo-pagination
        v-if="documentConfigIdProp===CHARGE_CHANGE"
        :config-module="type===WORKFLOW_TYPE_LOOK ? '33000606' : '44000606'"
        :total="total"
        :page.sync="filter.pageNum"
        :limit.sync="filter.pageSize"
        @pagination="toQuery"
      />
      <!--我发起的/我处理的-临时信控申请单-->
      <cargo-pagination
        v-if="documentConfigIdProp===TEMP_CREDIT"
        :config-module="type===WORKFLOW_TYPE_LOOK ? '33000505' : '44000505'"
        :total="total"
        :page.sync="filter.pageNum"
        :limit.sync="filter.pageSize"
        @pagination="toQuery"
      />
      <!--我发起的/我处理的-收票申请单-->
      <cargo-pagination
        v-if="documentConfigIdProp===COLLECT_INVOICE"
        :config-module="type===WORKFLOW_TYPE_LOOK ? '33000707' : '44000707'"
        :total="total"
        :page.sync="filter.pageNum"
        :limit.sync="filter.pageSize"
        @pagination="toQuery"
      />
      <!--我发起的/我处理的-合作伙伴申请单-->
      <cargo-pagination
        v-if="documentConfigIdProp===PARTNER_APPLICATION_FORM"
        :config-module="type===WORKFLOW_TYPE_LOOK ? '33000808' : '44000808'"
        :total="total"
        :page.sync="filter.pageNum"
        :limit.sync="filter.pageSize"
        @pagination="toQuery"
      />
      <!--我发起的/我处理的-合同申请单-->
      <cargo-pagination
        v-if="documentConfigIdProp===CONTRACT_APPLICATION_FORM"
        :config-module="type===WORKFLOW_TYPE_LOOK ? '33000909' : '44000909'"
        :total="total"
        :page.sync="filter.pageNum"
        :limit.sync="filter.pageSize"
        @pagination="toQuery"
      />
    </div>
    <!-- 付款申请审批流 -->
    <!-- <bill-payment-work-flow-apply-dialog
      v-if="workFlowApplyDialog.visible"
      :visible.sync="workFlowApplyDialog.visible"
      :status="status"
      :bill-payment="billPayment"
      :title="applyDialogTitle"
      :process-info="selectRow"
      :records="approvalCommentsRecords"
      :type="type"
      @close="workFlowApplyDialog.visible=false"
      @closeAndRefresh="()=> {
        workFlowApplyDialog.visible = false
        applyCloseAndRefresh() }"
    /> -->
    <!-- 业务申请审批流 -->
    <job-apply-dialog
      v-if="jobApplyDialog.visible"
      :visible.sync="jobApplyDialog.visible"
      :title="applyDialogTitle"
      :process-info="selectRow"
      :records="approvalCommentsRecords"
      :type="type"
      :doc-id="docId"
      :document-config-id="documentConfigId"
      @close="jobApplyDialog.visible=false"
      @closeAndRefresh="()=> {
        jobApplyDialog.visible = false
        applyCloseAndRefresh()
      }"
    />
    <!-- 开票申请审批流/收票申请审批流 -->
    <!-- 开票弹窗 -->
    <invoice-detail-dialog
      v-if="invoiceDetailDialog.visible"
      ref="makeInvoiceDialog"
      :is-bpm="true"
      :process-info="selectRow"
      :records="approvalCommentsRecords"
      :type="type"
      :visible.sync="invoiceDetailDialog.visible"
      :title="$t('Invoice.invoice_invoiceInformation')"
      :properties="invoiceProperties"
      :last-process-node="lastProcessNode"
      view-source="tabInvoiceQuery"
      @pageChange="pageChange"
      @close="invoiceDetailDialog.visible=false"
      @closeAndRefresh="()=> {
        invoiceDetailDialog.visible=false
        applyCloseAndRefresh()
      }"
    />
    <!-- 开票申请审批流 -->
    <!-- 账单弹窗 -->
    <bill-dialog
      v-if="billDialog.visible"
      ref="billDialog"
      :is-bpm="true"
      :process-info="selectRow"
      :records="approvalCommentsRecords"
      :type="type"
      :visible.sync="billDialog.visible"
      :billing-uuid="docId"
      :is-view="true"
      :last-process-node="lastProcessNode"
      @close="billDialog.visible=false"
      @closeAndRefresh="()=> {
        billDialog.visible=false
        applyCloseAndRefresh()
      }"
    />
    <!-- 费用改变审批流 -->
    <charge-apply-dialog
      v-if="chargeWorkFlowApplyDialog.visible"
      ref="workFlowApplyDialog"
      :visible.sync="chargeWorkFlowApplyDialog.visible"
      :change-charge="chargeWorkFlowApplyDialog.changeCharge"
      :title="applyDialogTitle"
      :process-info="selectRow"
      :records="records"
      :type="type"
      @close="chargeWorkFlowApplyDialog.visible=false"
      @closeAndRefresh="()=> {
        chargeWorkFlowApplyDialog.visible=false
        applyCloseAndRefresh()
      }"
    />
    <company-apply-dialog
      v-if="companyDialog.visible"
      ref="companyApplyDialog"
      :visible.sync="companyDialog.visible"
      :company-bpm="companyDialog.companyBpm"
      :title="applyDialogTitle"
      :process-info="selectRow"
      :records="approvalCommentsRecords"
      :type="type"
      @close="companyDialog.visible=false"
      @closeAndRefresh="()=> {
        companyDialog.visible=false
        applyCloseAndRefresh()
      }"
    />
    <!-- 合同bpm申请弹框    -->
    <contract-apply-dialog
      v-if="contractDialog.visible"
      ref="contractApplyDialog"
      :visible.sync="contractDialog.visible"
      :contract-bpm="contractDialog.contractBpm"
      :title="applyDialogTitle"
      :process-info="selectRow"
      :records="approvalCommentsRecords"
      :type="type"
      @close="contractDialog.visible=false"
      @closeAndRefresh="()=> {
        contractDialog.visible=false
        applyCloseAndRefresh()
      }"
    />
    <!-- 临时信控审批流 -->
    <!-- 临时信控弹窗 -->
    <temp-credit-apply-dialog
      v-if="tempCreditApplyDialog.visible"
      ref="tempCreditApplyDialog"
      :is-bpm="true"
      :process-info="selectRow"
      :records="approvalCommentsRecords"
      :type="type"
      :visible.sync="tempCreditApplyDialog.visible"
      :doc-id="docId"
      @close="tempCreditApplyDialog.visible=false"
      @closeAndRefresh="()=> {
        tempCreditApplyDialog.visible=false
        applyCloseAndRefresh()
      }"
    />
    <process-records
      v-if="processRecordsDialog.visible"
      :visible.sync="processRecordsDialog.visible"
      :process-detail="processDetail"
      :records="records"
      :workflow-name="workflowName"
      :document-config-name="documentConfigName"
      @close="processRecordsDialog.visible=false"
    />
    <!-- 文件管理弹窗 -->
    <file-manage-dialog :visible.sync="fileManageDialog.visible" :files="fileManageDialog.files" />
    <!-- 预览文件弹窗 -->
    <pre-view-file-dialog
      :title="$t('FileHistory.preview')"
      :visible="previewFileData.visible"
      :file="previewFileData.file"
      :can-maximize="true"
      @close="closePreviewDialog"
    />
  </div>
</template>

<script>
import ColumnUtils from '@/utils/ColumnUtils'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import { getLoading } from '@/utils/utilBaseElement'
import { existWorkflowGroup, getDocumentProcess, workflowHistory } from '@/api/workflow'
import { queryBillPaymentDetail } from '@/api/clearing/billPayment'
import { DocumentManage, Once, stringToBool } from '@/utils/commonUtil'
import ProcessRecords from '@/views/cargo/v0/ApprovalMatters/ApprovalChecklist/components/ProcessRecords'
import BillPaymentWorkFlowApplyDialog from '@/components/Cargo/Common/Wrokflow/billPaymentApplyDialog'
import * as WorkflowConstants from '@/class/cargo/model/parameters/WorkflowConstants'
import { getGridSelected } from '@/utils/agGrid'
import JobApplyDialog from '@/components/Cargo/Common/Wrokflow/jobApplyDialog'
import {
  APPLICATION_DIMENSION_BILL,
  BILL_PAYMENT, CHARGE_CHANGE, COLLECT_INVOICE, CONTRACT_APPLICATION_FORM,
  Job_CHARGE,
  MAKE_INVOICE, MAKE_INVOICE_INTERNAL_INVOICE, PARTNER_APPLICATION_FORM, TEMP_CREDIT, WORKFLOW_DISCARD
} from '@/class/cargo/model/parameters/WorkflowConstants'
import InvoiceDetailDialog from '@/views/cargo/v0/Clearing/components/makeInvoice/invoiceDetailDialog'
import { getInvoiceDetails } from '@/api/clearing/invoice'
import StrUtils from '@/utils/StrUtils'
import BillDialog from '@/components/Cargo/Act/billDialog'
import { cache, cacheName } from '@/utils/cacheManager'
import CustomLableUtils from '@/utils/CustomLabelUtils'
import * as NumberUtils from '@/utils/NumberUtils'
import { formatNumberToThousands } from '@/utils'
import { getWorkFlowChangeCharge } from '@/api/clearing/changeChargeBpm'
import chargeApplyDialog from '@/components/Cargo/Common/Wrokflow/chargeApplyDialog'
import TempCreditApplyDialog from '@/components/Cargo/Common/Wrokflow/tempCreditApplyDialog'
import OperationRender from '@/components/OperationRender/index'
import FileManageDialog from '@/views/cargo/v0/ApprovalMatters/ApprovalChecklist/components/FileManageDialog'
import preViewFileDialog from '@/components/Cargo/Common/preViewFileCommonDialog'
import URL from '@/api/urlTranslator'
import { jumpFinaceOrBusiness } from '@/components/Cargo/grid/routerAndPrintHelp'
import GlobalDialog from '@/utils/GlobalDialog'
import { WorkflowUtil } from '@/class/cargo/model/utils/WorkflowUtil'
import chargeCurrencyTotalGroup from '@/components/Cargo/Act/chargeSummary/ChargeCurrencyTotalGroup.vue'
import * as RateUtil from '@/class/cargo/model/utils/RateUtil'
import { getObjectByCache } from '@/utils/basicDataCache'
import { basicCacheKeys } from '@/utils/cacheConfig'
import { getWorkFlowCompany } from '@/api/partner/companyBpm'
import CompanyApplyDialog from '@/components/Cargo/Common/Wrokflow/companyApplyDialog.vue'
import { getWorkFlowContract } from '@/api/partner/contractBpm'
import * as ContractConstants from '@/class/cargo/model/parameters/ContractConstants'
import ContractApplyDialog from '@/components/Cargo/Common/Wrokflow/contractApplyDialog.vue'

export default {
  name: 'ApprovalListGrid',
  components: { ContractApplyDialog, CompanyApplyDialog, chargeCurrencyTotalGroup, ProcessRecords, BillPaymentWorkFlowApplyDialog, JobApplyDialog, InvoiceDetailDialog, BillDialog, chargeApplyDialog, TempCreditApplyDialog, FileManageDialog, preViewFileDialog },
  props: {
    status: { type: Number, default: 0 },
    type: { type: String, default: '' },
    configModule: { type: String, default: '', required: true },
    rowData: { type: Array, default: () => [] },
    total: { type: Number, default: 0 },
    // 是否选择表单类型
    documentConfigIdProp: { type: Number, default: 0 },
    perConfigName: { type: String, default: '' },
    gridRefreshId: { type: Number, default: 0 },
    // 是否是动态创建弹窗
    dynamics: { type: Boolean, default: () => true }
  },
  data() {
    return {
      filter: {
        pageNum: 1,
        pageSize: 50
      },
      documentManage: new DocumentManage(),
      selectRow: {},
      records: [],
      approvalCommentsRecords: [],
      processRecordsDialog: {
        visible: false
      },
      workFlowApplyDialog: {
        visible: false
      },
      chargeWorkFlowApplyDialog: {
        changeCharge: {},
        visible: false
      },
      localCurrency: 'RMB',
      reCalc: true,
      dataShow: true, // 底部计算组件文字是否显示
      selections: [], // 已经选中列表
      once: new Once(this),
      totalAmountToCurrencyBillPaymentGrid: { // 右下角合计组件相关参数
        selectionCountLabel: '',
        dataProvider: [], // 数据源
        selectedCount: 0 // 选中条数
      },
      workflowStates: Array.from(WorkflowConstants.WORKFLOW_STATE),
      workflowTemplates: Array.from(WorkflowConstants.WORKFLOW_TYPES),
      billPayment: {},
      selectTypeNames: TYPE_NAMES,
      gridParams: {},
      gridApi: null,
      gridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: true,
        context: {
          componentParent: this
        },
        onRowDoubleClicked: this.onRowDoubleClicked,
        onSortChanged: this.onSortChanged,
        onSelectionChanged: event => {
          const selectedRows = event.api.getSelectedRows()
          this.$emit('changeSelected', selectedRows)
        },
        getRowStyle: params => {
          if (params.data.documentProcessNo === this.$store.state.dialogStatus.approvalNo) {
            return { backgroundColor: '#f0f8ff' } // 高亮行的背景色
          }
          return null
        }
      },
      // 通用显示列
      columnDefs: [
        {
          headerName: '', width: 55, checkboxSelection: true,
          headerCheckboxSelection: true,
          sortable: false, suppressMenu: true, suppressSizeToFit: true, resizable: false
        },
        {
          headerName: this.$t('CargoMsg.Cargo_ApprovalSerialNumber'), field: 'documentProcessNo', colId: 'documentProcessNo', flex: 1,
          excelRenderer: (params) => {
            return params.value
          },
          cellRenderer: (params) => {
            const methodPath = this.documentManage.getPath('detailWrapper')
            return `<a onclick="${methodPath}(null, ${params.data.id})" style="color:blue">` + params.value + '</a>'
          },
          filterParams: {},
          filterValueGetter: (params) => {
            return params.data.documentProcessNo ? params.data.documentProcessNo : ''
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_ApplicationDimension'), field: 'applicationDimension', colId: 'applicationDimension', flex: 1,
          valueFormatter: (params) => {
            return ColumnUtils.applicationDimensionLabel(params.value)
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_ApplicationCode'), field: 'docNo', colId: 'docNo', flex: 1
        },
        {
          headerName: this.$t('CargoMsg.Cargo_StartTime'), field: 'createDate', colId: 'createDate', flex: 1
        },
        {
          headerName: this.$t('CargoMsg.Cargo_ProcessName'), field: 'workflowName', colId: 'workflowName', flex: 1
        },
        {
          headerName: this.$t('CargoMsg.Cargo_CurrentApprover'), field: 'approveId', colId: 'approveId', flex: 1,
          valueFormatter: (params) => {
            return ColumnUtils.resolveMultipleColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'chineseName')
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_Status'), field: 'state', colId: 'state', flex: 1,
          valueFormatter: (params) => {
            const stateContent = this.workflowStates.filter(item => item.code === params.value)
            if (!stateContent || stateContent.length === 0) {
              return ''
            }
            return this.isZh ? stateContent[0].chineseName : stateContent[0].englishName
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_InitiateBranchCompany'), field: 'officeId', colId: 'officeId', flex: 1,
          valueFormatter: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Office, 'officeId', Number(params.value), 'chineseName')
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_Initiator'), field: 'creatorId', colId: 'creatorId', flex: 1,
          valueFormatter: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'chineseName')
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_Operation'), field: '', colId: '', flex: 1,
          cellRenderer: params => {
            const reviewTheProcessRecord = this.documentManage.getPath('toReviewTheProcessRecord')
            const documentProcessId = params.data.documentProcessId
            const docId = params.data.docId
            const workflowName = params.data.workflowName
            const documentConfigName = params.data.documentConfigName
            const officeId = params.data.officeId
            const documentConfigId = params.data.documentConfigId
            return `<div onclick="${reviewTheProcessRecord}(${documentProcessId}, '${docId}', '${workflowName}', '${documentConfigName}', ${officeId}, ${documentConfigId})" style="display: inline-block;color:dodgerblue;margin-right: 5px;cursor: pointer">${this.$t('CargoMsg.Cargo_ReviewTheProcessRecord')}</div>`
          }
        },
        {
          headerName: this.$t('SeaExport.DateModified'), field: 'lastModified', colId: 'lastModified', flex: 1
        }
      ],
      processDetail: [],
      documentConfigName: '',
      workflowName: '',
      loading: null,
      jobApplyDialog: {
        visible: false
      },
      docId: null,
      documentConfigId: null,
      invoiceDetailDialog: {
        visible: false
      },
      billDialog: {
        visible: false
      },
      tempCreditApplyDialog: {
        visible: false
      },
      companyDialog: {
        visible: false,
        companyBpm: {}
      },
      contractDialog: {
        visible: false,
        contractBpm: {}
      },
      lastProcessNode: '', // 最新的节点
      invoiceProperties: {
        // mode: 0, // 弹窗模式[default:0] 0-开票模式  1-对冲开票模式
        isHedge: false, // 是否对冲
        isAr: true, // 是否应收

        makeInvoiceMethod: 1, // 开票方式: 1=费用、2=业务、3=账单、4=对账单
        makeInvoiceMethodHedge: 1, // 开票方式: 1=费用、2=业务、3=账单、4=对账单

        typeGroup: 'multi', // 开票类型：multi=合并开票、job=按业务开票、single=按记录开票、settlementAgent=按结算代理开票
        invoiceType: 0, // 发票类型：0=普通发票、1=专用发票、2=增值税普通发票、3=增值税专用发票、4=内部发票
        groupingMakeType: 0, // 发票种类：0=纸质发票、1=电子发票

        currencyGroup: 0, // 分币种开票：0=拆分币种开票、1=合并币种
        cbAssignCurrency: true, // 指定发票币种
        groupingCurrencyType: 0, // currencyGroup + cbAssignCurrency: 0=合并币种、1=拆分币种+指定发票币种、2=拆分币种+非指定发票币种
        currency: 'RMB', // 币种

        showChargeDetail: false, // 是否显示费用明细
        useDefaultRate: false, // 按财务汇率开票
        isInvoicingByBillingRate: false, // 按账单汇率
        billingRateMap: {}, // 账单币种、账单汇率
        makeCostInvoice: false, // 生成成本发票
        isGenCostInvoice: false, // 是否生成成本发票: isAr ? makeCostInvoice : false
        costInvoiceProp: {},
        defaultContent: false, // 将本次内容设置为默认开票信息

        invoiceGoodsName: {}, // 发票项目名称
        settleDepartment: 0, // 结算部门
        settleDepartmentPrefix: '', // 结算部门归属工作号

        otherCurrencys: [], // 其它币种
        otherRates: [], // 其它币种汇率
        txtCurrency1: '',
        txtRate1: '',
        txtCurrency2: '',
        txtRate2: '',
        rateCache: {}, // 对比发票币种的汇率
        cbAlwarysUseRate: false, // 一直按该汇率开票

        branchId: this.$store.getters.currentOfficeId, // 分公司 Session.getInstance().getOfficeId()
        inputByDep: this.$store.getters.currentDeptId, // 部门 Session.getInstance().currentDepartment.departmentId

        titleMap: {}, // 获取账单所对应的结算单位: getTitleMap()
        invoiceByType: '', // 确认是否应当添加账单中的开票需求: getClassType(entities)
        hedgeInvoiceByType: '', // 确认是否应当添加账单中的开票需求: getClassType(hedgeEntities)

        selectedEntities: [], // 已经选中的实体
        selectedEntitiesHedge: [], // 已经选中的对冲实体
        entities: [], // 开票实体
        hedgeEntities: [], // 对冲实体
        allEntities: [], // 所有实体
        allCharges: [],
        chargeMap: {},
        invoices: [], // 生成发票列表
        invoice: {}, // 当前发票
        currentPage: 1, // 顺序号
        totalPage: 0, // 发票总数
        invoiceGoodsNameList: [], // 发票项目名称列表
        invoiceItemGoodsName: 0, // InvoiceItemGoodsName：开票发票项目默认货物或应税劳务名称
        defaultGoodsName: '', // InvoiceMergeName：合并开票费用名称
        receivedRadio: 'ALL', // 对冲开票，应收列表币种：全部/RMB/USD
        paymentRadio: 'ALL', // 对冲开票，应付列表币种：全部/RMB/USD
        showChargeDetailByInvoice: false, // ShowChargeDetailByInvoice：增值发票是否可以显示明细
        invoiceNoEditable: false, // InvoiceSearchEdit: 开票查询修改发票号
        costInfo: false, // costSplitInfo: 是否开启费用拆分金额校验
        useAutoCheckInvoicing: false, // 是否使用了自动勾选开票
        autoCheckInvoiceAmountEnable: false, // 是否使用自动勾选开票
        autoCheckInvoicingAmount: 0.00, // 自动勾选开票预设金额
        isInvoiceByEachBillingRate: false, // isInvoiceByEachBillingRate：是否按各自账单汇率来开票
        invoiceTriggerBpm: false
      },
      WORKFLOW_TYPE_LOOK: WorkflowConstants.WORKFLOW_TYPE_LOOK.code,
      WORKFLOW_TYPE_APPROVE: WorkflowConstants.WORKFLOW_TYPE_APPROVE.code,
      BILL_PAYMENT: WorkflowConstants.BILL_PAYMENT.code,
      MAKE_INVOICE: WorkflowConstants.MAKE_INVOICE.code,
      Job_CHARGE: WorkflowConstants.Job_CHARGE.code,
      CHARGE_CHANGE: WorkflowConstants.CHARGE_CHANGE.code,
      TEMP_CREDIT: WorkflowConstants.TEMP_CREDIT.code,
      COLLECT_INVOICE: WorkflowConstants.COLLECT_INVOICE.code,
      PARTNER_APPLICATION_FORM: WorkflowConstants.PARTNER_APPLICATION_FORM.code,
      CONTRACT_APPLICATION_FORM: WorkflowConstants.CONTRACT_APPLICATION_FORM.code,
      // 我发起的
      initiateGrid: {
        gridParams: {},
        gridOptions: {
          rowSelection: 'multiple',
          suppressCellSelection: true,
          context: {
            componentParent: this
          },
          onRowDoubleClicked: this.onRowDoubleClicked,
          onSortChanged: this.onSortChanged,
          onSelectionChanged: event => {
            const selectedRows = event.api.getSelectedRows()
            this.$emit('changeSelected', selectedRows)
          },
          defaultColDef: {
            resizable: true,
            filter: true
          },
          pagination: false
        },
        columnDefs: [
          {
            headerName: this.$t('CargoMsg.Cargo_ApprovalTemplate'), field: 'documentConfigName', colId: 'documentConfigName', flex: 1
          }
        ],
        rowData: [],
        total: 0,
        page: 1,
        limit: 20
      },
      // 我发起的/我处理的-付款申请单
      billPaymentGrid: {
        gridParams: {},
        gridOptions: {
          rowSelection: 'multiple',
          suppressCellSelection: true,
          context: {
            componentParent: this
          },
          onRowDoubleClicked: this.onRowDoubleClicked,
          onSortChanged: this.onSortChanged,
          onSelectionChanged: this.toRefreshSelectedCountChargeGrid,
          defaultColDef: {
            resizable: true,
            filter: true
          },
          pagination: false
        },
        columnDefs: [
          {
            headerName: this.$t('Payment.remarks'), field: 'remarks', width: 100,
            tooltipValueGetter: (params) => params.value
          },
          {
            headerName: this.$t('CargoMsg.Cargo_Operation'), field: '', colId: '', flex: 1,
            cellRenderer: params => {
              const reviewTheProcessRecord = this.documentManage.getPath('toReviewTheProcessRecord')
              const documentProcessId = params.data.documentProcessId
              const docId = params.data.docId
              const workflowName = params.data.workflowName
              const documentConfigName = params.data.documentConfigName
              const officeId = params.data.officeId
              const documentConfigId = params.data.documentConfigId
              return `<div onclick="${reviewTheProcessRecord}(${documentProcessId}, '${docId}', '${workflowName}', '${documentConfigName}', ${officeId}, ${documentConfigId})" style="display: inline-block;color:dodgerblue;margin-right: 5px;cursor: pointer">${this.$t('CargoMsg.Cargo_ReviewTheProcessRecord')}</div>`
            }
          },
          {
            headerName: this.$t('SeaExport.DateModified'), field: 'lastModified', colId: 'lastModified', flex: 1
          },
          {
            headerName: this.$t('Payment.settleAccountsTo'), field: 'accountId', width: 300,
            cellRenderer: (params) => {
              return params.value ? CustomLableUtils.getLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'auto_accountId') : ''
            }
          },
          {
            headerName: this.$t('Payment.businessNumber'),
            field: 'jobNos'
          },
          {
            headerName: this.$t('Invoice.invoice_invoiceNo'), field: 'invoiceNos', width: 200
          },
          {
            headerName: this.$t('Payment.currency'), field: 'currency', width: 200
          },
          {
            headerName: this.$t('Payment.amount'), field: 'amount', width: 200,
            cellRenderer: (params) => {
              if (!params.value) {
                return ''
              }
              return NumberUtils.formatRoundNumber(params.value, 2)
            }
          },
          { headerName: this.$t('Payment.settlementType'),
            field: 'settlementType',
            width: 200,
            cellRenderer: (params) => {
              return ColumnUtils.settlementTypeCommonLabelFunc(params.data)
            },
            filterParams: {},
            filterValueGetter: params => ColumnUtils.settlementTypeCommonLabelFunc(params.data)
          },
          {
            headerName: this.$t('Payment.paymentPeriod'), field: 'deadline', width: 200,
            cellRenderer: (params) => {
              return ColumnUtils.dateLabelFunc(params.value)
            }
          },
          {
            headerName: this.$t('Payment.totalCurrency'), field: 'currencyAmount', width: 220, hide: true
          },
          {
            headerName: this.$t('Billing.billingJob_agentBillNo'), field: 'counterPartyBillingNos', width: 200, hide: true
          },
          {
            headerName: this.$t('Payment.writeOffStatus'), field: 'realClearingState', width: 150, hide: true,
            cellRenderer: (params) => {
              return ColumnUtils.clearingStateLabFun(params.value)
            }
          },
          {
            headerName: this.$t('Partners.paymentType'), field: 'paymentType', width: 200, hide: true,
            cellRenderer: (params) => {
              if (String(params.value) === '') {
                return ''
              }
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_PaymentType, 'code', String(params.value), 'name')
            },
            filterParams: {},
            filterValueGetter: (params) => {
              const paymentType = params.data.paymentType
              if (paymentType === '' || paymentType === undefined) {
                return ''
              }
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_PaymentType, 'code', paymentType, 'name')
            }
          }
          // {
          //   headerName: this.$t('Payment.theAmountOfWriteOffs'), field: 'verifiedAmount', width: 200,
          //   cellRenderer: (params) => {
          //     return params.value === 0 ? '' : NumberUtils.formatRoundNumber(params.value, 2)
          //   }
          // }
        ],
        rowData: [],
        total: 0,
        page: 1,
        limit: 20
      },
      // 我发起的/我处理的-开票申请单
      makeInvoiceGrid: {
        gridParams: {},
        gridOptions: {
          rowSelection: 'multiple',
          suppressCellSelection: true,
          context: {
            componentParent: this
          },
          onRowDoubleClicked: this.onRowDoubleClicked,
          onSortChanged: this.onSortChanged,
          onSelectionChanged: event => {
            const selectedRows = event.api.getSelectedRows()
            this.$emit('changeSelected', selectedRows)
          },
          defaultColDef: {
            resizable: true,
            filter: true
          },
          pagination: false
        },
        columnDefs: [
          { headerName: this.$t('Invoice.invoice_settlementCompany'),
            field: 'accountId',
            cellRenderer: (params) => {
              return params.value ? CustomLableUtils.getLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'auto_accountId') : ''
            },
            width: 200
          },
          { headerName: this.$t('Invoice.invoice_invoiceHeader'),
            field: 'title',
            width: 200
          },
          {
            headerName: this.$t('Payment.businessNumber'),
            field: 'jobNo',
            cellRendererFramework: 'agGridColumnEdit',
            custom: {
              tag: 'multi-router-and-print',
              attrs: params => {
                const data = params.data
                return {
                  useRoute: true,
                  usePrint: false,
                  jumpMethod: value => {
                    jumpFinaceOrBusiness(this, value, '', data.branchId)
                  }
                }
              }
            },
            width: 150
          },
          { headerName: this.$t('Invoice.invoice_invoiceCategory'),
            field: 'makeType',
            cellRenderer: (params) => {
              return ColumnUtils.electronicInvoiceColumnFunc(Number(params.value))
            },
            width: 100
          },
          {
            headerName: this.$t('Invoice.invoice_invoicingCurrency'),
            field: 'currency',
            width: 100
          },
          { headerName: this.$t('Invoice.invoice_InvoicingAmount'),
            field: 'amount',
            cellRenderer: (params) => {
              if (!params.value) {
                return ''
              }
              return formatNumberToThousands(ColumnUtils.number2ColumnLabelFunc(params.value), 2)
            },
            width: 100
          },
          { headerName: this.$t('Invoice.invoice_invoiceRemarks'),
            field: 'remark',
            width: 200
          },
          { headerName: this.$t('Payment.settlementType'),
            field: 'settlementType',
            width: 200,
            cellRenderer: (params) => {
              return ColumnUtils.settlementTypeCommonLabelFunc(params.data)
            },
            filterParams: {},
            filterValueGetter: params => ColumnUtils.settlementTypeCommonLabelFunc(params.data)
          }
        ],
        rowData: [],
        total: 0,
        page: 1,
        limit: 20
      },
      // 我发起的/我处理的-业务费用申请单
      jobChargeGrid: {
        gridParams: {},
        gridOptions: {
          rowSelection: 'multiple',
          suppressCellSelection: true,
          context: {
            componentParent: this
          },
          onRowDoubleClicked: this.onRowDoubleClicked,
          onSortChanged: this.onSortChanged,
          onSelectionChanged: event => {
            const selectedRows = event.api.getSelectedRows()
            this.$emit('changeSelected', selectedRows)
          },
          defaultColDef: {
            resizable: true,
            filter: true
          },
          pagination: false
        },
        columnDefs: [
          {
            headerName: this.$t('SeaExport.ConsignationCompany'),
            colId: 'customerId',
            field: 'customerId',
            valueFormatter: (params) => {
              return params.value ? CustomLableUtils.getLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'auto_0') : ''
            },
            width: 200
          }, {
            headerName: this.$t('CargoMsg.Cargo_BusinessCreateDate'),
            field: 'dateCreated',
            colId: 'dateCreated',
            width: 150,
            valueFormatter: params => {
              return ColumnUtils.dateTimeLabelFunc(params.value)
            }
          }, {
            headerName: this.$t('CargoMsg.Cargo_ETD'),
            field: 'etd',
            colId: 'etd',
            width: 150,
            valueFormatter: params => {
              return ColumnUtils.dateLabelFunc(params.value)
            }
          }, {
            headerName: this.$t('CargoMsg.Cargo_ETA'),
            field: 'eta',
            colId: 'eta',
            width: 150,
            valueFormatter: params => {
              return ColumnUtils.dateLabelFunc(params.value)
            }
          }, {
            headerName: this.$t('CargoMsg.Cargo_ATD'),
            field: 'atd',
            colId: 'atd',
            cellRenderer: (params) => {
              return ColumnUtils.dateLabelFunc(params.value)
            },
            width: 150
          }, {
            headerName: this.$t('CargoMsg.Cargo_ATA'),
            field: 'ata',
            colId: 'ata',
            cellRenderer: (params) => {
              return ColumnUtils.dateLabelFunc(params.value)
            },
            width: 150
          }
        ],
        rowData: [],
        total: 0,
        page: 1,
        limit: 20
      },
      // 我发起的/我处理的-费用更改申请单
      chargeChangeGrid: {
        gridParams: {},
        gridOptions: {
          rowSelection: 'multiple',
          suppressCellSelection: true,
          context: {
            componentParent: this
          },
          onRowDoubleClicked: this.onRowDoubleClicked,
          onSortChanged: this.onSortChanged,
          onSelectionChanged: event => {
            const selectedRows = event.api.getSelectedRows()
            this.$emit('changeSelected', selectedRows)
          },
          defaultColDef: {
            resizable: true,
            filter: true
          },
          pagination: false
        },
        columnDefs: [
          {
            headerName: this.$t('SeaExport.ConsignationCompany'),
            colId: 'customerId',
            field: 'customerId',
            valueFormatter: (params) => {
              return params.value ? CustomLableUtils.getLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'auto_0') : ''
            },
            width: 200
          }, {
            headerName: this.$t('CargoMsg.Cargo_BusinessCreateDate'),
            field: 'dateCreated',
            colId: 'dateCreated',
            width: 150,
            valueFormatter: params => {
              return ColumnUtils.dateTimeLabelFunc(params.value)
            }
          }, {
            headerName: this.$t('CargoMsg.Cargo_ETD'),
            field: 'etd',
            colId: 'etd',
            width: 150,
            valueFormatter: params => {
              return ColumnUtils.dateLabelFunc(params.value)
            }
          }, {
            headerName: this.$t('CargoMsg.Cargo_ETA'),
            field: 'eta',
            colId: 'eta',
            width: 150,
            valueFormatter: params => {
              return ColumnUtils.dateLabelFunc(params.value)
            }
          }, {
            headerName: this.$t('CargoMsg.Cargo_ATD'),
            field: 'atd',
            colId: 'atd',
            cellRenderer: (params) => {
              return ColumnUtils.dateLabelFunc(params.value)
            },
            width: 150
          }, {
            headerName: this.$t('CargoMsg.Cargo_ATA'),
            field: 'ata',
            colId: 'ata',
            cellRenderer: (params) => {
              return ColumnUtils.dateLabelFunc(params.value)
            },
            width: 150
          }
        ],
        rowData: [],
        total: 0,
        page: 1,
        limit: 20
      },
      // 我发起的/我处理的-临时信控申请单
      tempCreditGrid: {
        gridParams: {},
        gridOptions: {
          rowSelection: 'multiple',
          suppressCellSelection: true,
          context: {
            componentParent: this
          },
          onRowDoubleClicked: this.onRowDoubleClicked,
          onSortChanged: this.onSortChanged,
          onSelectionChanged: event => {
            const selectedRows = event.api.getSelectedRows()
            this.$emit('changeSelected', selectedRows)
          },
          defaultColDef: {
            resizable: true,
            filter: true
          },
          pagination: false
        },
        columnDefs: [
          {
            headerName: this.$t('CargoMsg.Cargo_PartnerName'),
            colId: 'companyName',
            field: 'companyName',
            width: 200
          }, {
            headerName: this.$t('CargoMsg.Cargo_ContractNumber2'),
            field: 'contractNo',
            colId: 'contractNo',
            width: 150
          }, {
            headerName: this.$t('CargoMsg.Cargo_ContractAmount'),
            field: 'credit',
            colId: 'credit',
            width: 150,
            cellRenderer: params => {
              return ColumnUtils.creditLabelFunc(params.data)
            },
            filterValueGetter: params => {
              return ColumnUtils.creditLabelFunc(params.data)
            },
            filterParams: {}
          }, {
            headerName: this.$t('CargoMsg.Cargo_ContractAccountingPeriod'),
            field: 'creditDateLimited',
            colId: 'creditDateLimited',
            width: 150,
            cellRenderer: params => {
              return ColumnUtils.AccountPeriodLabelFunc(params.data)
            },
            filterValueGetter: params => {
              return ColumnUtils.AccountPeriodLabelFunc(params.data)
            },
            filterParams: {}
          }, {
            headerName: this.$t('CargoMsg.Cargo_SettlementType'),
            field: 'settlementType',
            colId: 'settlementType',
            width: 100,
            cellRenderer: params => ColumnUtils.creditDateTypeColumnLabelFunc2(params.data),
            filterParams: {},
            filterValueGetter: (params) => {
              return ColumnUtils.creditDateTypeColumnLabelFunc2(params.data)
            }
          }
        ],
        rowData: [],
        total: 0,
        page: 1,
        limit: 20
      },
      // 我发起的/我处理的-开票申请单
      collectInvoiceGrid: {
        gridParams: {},
        gridOptions: {
          rowSelection: 'multiple',
          suppressCellSelection: true,
          context: {
            componentParent: this
          },
          onRowDoubleClicked: this.onRowDoubleClicked,
          onSortChanged: this.onSortChanged,
          onSelectionChanged: event => {
            const selectedRows = event.api.getSelectedRows()
            this.$emit('changeSelected', selectedRows)
          },
          defaultColDef: {
            resizable: true,
            filter: true
          },
          pagination: false
        },
        columnDefs: [
          { headerName: this.$t('Invoice.invoice_settlementCompany'),
            field: 'accountId',
            cellRenderer: (params) => {
              return params.value ? CustomLableUtils.getLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'auto_accountId') : ''
            },
            width: 200
          },
          { headerName: this.$t('Invoice.invoice_invoiceHeader'),
            field: 'title',
            width: 200
          },
          {
            headerName: this.$t('Payment.businessNumber'),
            field: 'jobNo',
            cellRendererFramework: 'agGridColumnEdit',
            custom: {
              tag: 'multi-router-and-print',
              attrs: params => {
                const data = params.data
                return {
                  useRoute: true,
                  usePrint: false,
                  jumpMethod: value => {
                    jumpFinaceOrBusiness(this, value, '', data.branchId)
                  }
                }
              }
            },
            width: 150
          },
          { headerName: this.$t('Invoice.invoice_invoiceCategory'),
            field: 'makeType',
            cellRenderer: (params) => {
              return ColumnUtils.electronicInvoiceColumnFunc(Number(params.value))
            },
            width: 100
          },
          {
            headerName: this.$t('Invoice.invoice_invoicingCurrency'),
            field: 'currency',
            width: 100
          },
          { headerName: this.$t('Invoice.invoice_InvoicingAmount'),
            field: 'amount',
            cellRenderer: (params) => {
              if (!params.value) {
                return ''
              }
              return formatNumberToThousands(ColumnUtils.number2ColumnLabelFunc(params.value), 2)
            },
            width: 100
          },
          { headerName: this.$t('Invoice.invoice_invoiceRemarks'),
            field: 'remark',
            width: 200
          },
          { headerName: this.$t('Payment.settlementType'),
            field: 'settlementType',
            width: 200,
            cellRenderer: (params) => {
              return ColumnUtils.settlementTypeCommonLabelFunc(params.data)
            },
            filterParams: {},
            filterValueGetter: params => ColumnUtils.settlementTypeCommonLabelFunc(params.data)
          }
        ],
        rowData: [],
        total: 0,
        page: 1,
        limit: 20
      },
      // 我发起的/我处理的-合作伙伴
      companyGrid: {
        gridParams: {},
        gridOptions: {
          rowSelection: 'multiple',
          suppressCellSelection: true,
          context: {
            componentParent: this
          },
          onRowDoubleClicked: this.onRowDoubleClicked,
          onSortChanged: this.onSortChanged,
          onSelectionChanged: event => {
            const selectedRows = event.api.getSelectedRows()
            this.$emit('changeSelected', selectedRows)
          },
          defaultColDef: {
            resizable: true,
            filter: true
          },
          pagination: false
        },
        columnDefs: [
          { headerName: this.$t('CargoMsg.Cargo_ChineseNamed'),
            field: 'chineseName',
            width: 200
          },
          { headerName: this.$t('CargoMsg.Cargo_EnglishNamed'),
            field: 'englishName',
            width: 200
          },
          {
            headerName: this.$t('CargoMsg.Cargo_Abbreviation'),
            field: 'shortName',
            width: 150
          },
          { headerName: this.$t('CargoMsg.Cargo_Code'),
            field: 'cnShortName',
            width: 100
          },
          {
            headerName: this.$t('CargoMsg.Cargo_RuleRole'),
            field: 'companyRole',
            width: 100,
            cellRenderer: (params) => {
              return ColumnUtils.companyRoleLabelFunction(params.value, TYPE_NAMES.local_cache_SystemConstants$COMPANY_ROLE_LIST)
            },
            tooltipValueGetter: (params) => {
              return ColumnUtils.companyRoleLabelFunction(params.value, TYPE_NAMES.local_cache_SystemConstants$COMPANY_ROLE_LIST)
            }
          },
          { headerName: this.$t('Partners.relatedBusinessType'),
            field: 'relatedBusinessType',
            width: 100,
            cellRenderer: (params) => {
              return ColumnUtils.companyRoleLabelFunction(params.value, TYPE_NAMES.local_cache_SystemConstants$PARTNER_LOB_ITEMS)
            },
            tooltipValueGetter: (params) => {
              return ColumnUtils.companyRoleLabelFunction(params.value, TYPE_NAMES.local_cache_SystemConstants$PARTNER_LOB_ITEMS)
            }
          },
          { headerName: this.$t('Partners.address'),
            field: 'companyAddress',
            width: 200
          },
          { headerName: this.$t('Partners.additionalDescription'),
            field: 'companyRemarks',
            width: 200
          }
        ],
        rowData: [],
        total: 0,
        page: 1,
        limit: 20
      },
      // 我发起的/我处理的-合同
      contractGrid: {
        gridParams: {},
        gridOptions: {
          rowSelection: 'multiple',
          suppressCellSelection: true,
          context: {
            componentParent: this
          },
          onRowDoubleClicked: this.onRowDoubleClicked,
          onSortChanged: this.onSortChanged,
          onSelectionChanged: event => {
            const selectedRows = event.api.getSelectedRows()
            this.$emit('changeSelected', selectedRows)
          },
          defaultColDef: {
            resizable: true,
            filter: true
          },
          pagination: false
        },
        columnDefs: [
          { headerName: this.$t('CargoMsg.Cargo_Parter'),
            field: 'companyUuid',
            cellRenderer: (params) => {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'uuid', params.value, 'chineseName')
            },
            width: 200
          },
          { headerName: this.$t('CargoMsg.Cargo_EffectiveDate'),
            field: 'beginDateStr',
            width: 200
          },
          { headerName: this.$t('CargoMsg.Cargo_InvalidDate'),
            field: 'endDateStr',
            width: 200
          },
          { headerName: this.$t('CargoMsg.Cargo_ContractAgreement'),
            field: 'contractAgreement',
            width: 200,
            valueFormatter: (params) => {
              return ColumnUtils.contractColumnLabelFunc(ContractConstants.CONTRACTAGREEMENT_TYPE, Number(params.value))
            }
          },
          { headerName: this.$t('CargoMsg.Cargo_SettlementMethod'),
            field: 'creditDateType',
            width: 200,
            valueFormatter: (params) => {
              if (params.value === 'n') {
                return ContractConstants.CREDITDATETYPE_DAY
              }
              return ColumnUtils.contractColumnLabelFunc(ContractConstants.CREDITDATETYPE_TYPE, Number(params.value))
            }
          },
          { headerName: this.$t('CargoMsg.Cargo_DateType'),
            field: 'dateType',
            width: 200,
            valueFormatter: (params) => {
              return ColumnUtils.contractColumnLabelFunc(ContractConstants.DATETYPE_TYPE, params.value)
            }
          },
          { headerName: this.$t('CargoMsg.Cargo_SettlementType'),
            field: 'settlementType',
            width: 200,
            valueFormatter: (params) => {
              if (!params.data && params.value === undefined) {
                return ''
              }
              return stringToBool(params.value) ? this.$t('CargoMsg.Cargo_SettlementNotByBill') : this.$t('CargoMsg.Cargo_SettlementByBill')
            }
          }
        ],
        rowData: [],
        total: 0,
        page: 1,
        limit: 20
      },
      attachColumn: {
        headerName: this.$t('CargoMsg.Cargo_Attachment'),
        field: 'attachment',
        width: 200,
        cellStyle: { textAlign: 'center' },
        cellRendererFramework: OperationRender,
        cellRendererParams: {
          operations: [
            {
              title: this.$t('CargoMsg.Cargo_Download'),
              type: 'primary',
              cssStyle: 'text-decoration: underline;',
              onClick: data => {
                if (data.documentTrackFiles.length > 1) {
                  this.fileManageDialog.files = data.documentTrackFiles
                  this.fileManageDialog.visible = true
                } else {
                  const url = `${URL.common.findByFileId}/${data.documentTrackFiles[0].fileId}?sessionId=${this.user.sessionId}`
                  window.open(url)
                }
              },
              visible: data => true,
              disabled: data => !(data.documentTrackFiles && data.documentTrackFiles.length > 0)
            },
            {
              title: this.$t('CargoMsg.Cargo_Preview'),
              type: 'primary',
              cssStyle: 'text-decoration: underline;',
              onClick: data => {
                if (data.documentTrackFiles.length > 1) {
                  this.fileManageDialog.files = data.documentTrackFiles
                  this.fileManageDialog.visible = true
                } else {
                  const file = data.documentTrackFiles[0]
                  const fileStr = file.fileName
                  const location = fileStr.lastIndexOf('.')
                  const type = fileStr.substring(location + 1, fileStr.length)
                  if (type === 'jpg' || type === 'png' || type === 'jpeg' || type === 'gif' || type === 'webp' || type === 'pdf' ||
                    type === 'doc' || type === 'docx' || type === 'xls' || type === 'xlsx') {
                    this.handlePreviewFile(file)
                  }
                }
              },
              visible: data => true,
              disabled: data => !(data.documentTrackFiles && data.documentTrackFiles.length > 0)
            }
          ]
        }
      },
      fileManageDialog: {
        visible: false,
        files: []
      },
      // 图片预览参数
      previewFileData: {
        visible: false,
        file: null
      },
      user: null
    }
  },
  computed: {
    isZh() {
      return this.$store.getters.language === 'zh'
    },
    applyDialogTitle() {
      return this.type === 'look' ? this.$t('CargoMsg.Cargo_ReviewTheApprovalProcess') : this.$t('CargoMsg.Cargo_Approving')
    },
    showBatchBtn() {
      return this.type === 'approve' && this.status === 0
    }
  },
  watch: {
    documentConfigIdProp: {
      immediate: true,
      async handler() {
        if (this.documentConfigIdProp === BILL_PAYMENT.code) {
          this.gridOptions = this.billPaymentGrid.gridOptions
        } else if (this.documentConfigIdProp === MAKE_INVOICE.code) {
          this.gridOptions = this.makeInvoiceGrid.gridOptions
        } else if (this.documentConfigIdProp === Job_CHARGE.code) {
          this.gridOptions = this.jobChargeGrid.gridOptions
        } else if (this.documentConfigIdProp === CHARGE_CHANGE.code) {
          this.gridOptions = this.chargeChangeGrid.gridOptions
        } else if (this.documentConfigIdProp === TEMP_CREDIT.code) {
          this.gridOptions = this.tempCreditGrid.gridOptions
        } else if (this.documentConfigIdProp === COLLECT_INVOICE.code) {
          this.gridOptions = this.collectInvoiceGrid.gridOptions
        } else if (this.documentConfigIdProp === PARTNER_APPLICATION_FORM.code) {
          this.gridOptions = this.companyGrid.gridOptions
        } else if (this.documentConfigIdProp === CONTRACT_APPLICATION_FORM.code) {
          this.gridOptions = this.contractGrid.gridOptions
        } else {
          this.gridOptions = this.initiateGrid.gridOptions
        }
      }
    },
    salesOffice() {
      this.salesCurrentOfficeChange()
    },
    rowData: {
      handler(data) {
        const approvalNo = this.$store.state.dialogStatus.approvalNo
        if (approvalNo) {
          this.$nextTick(() => {
            this.setLineColor(approvalNo)
          })
        }
        this.rowDataChange(data)
      },
      deep: true,
      immediate: true
    }
  },
  beforeMount() {
    const context = this
    this.documentManage.set('toReviewTheProcessRecord', function(key, uuid, workflowName, documentConfigName, officeId, documentConfigId) {
      context.toReviewTheProcessRecord(key, uuid, workflowName, documentConfigName, officeId, documentConfigId)
    })
    this.documentManage.set('detailWrapper', function(data, id) {
      context.detailWrapper(data, id)
    })
  },
  async created() {
    this.initiateGrid.columnDefs = [...this.columnDefs]
    // CARGO-42942 审批事项清单-付款申请单加【备注】显示列 备注列需要放在操作的左侧
    const tempColumnDefs = this.columnDefs.filter((column) => {
      return column.field !== '' && column.field !== 'lastModified'
    })
    this.billPaymentGrid.columnDefs = [...tempColumnDefs, ...this.billPaymentGrid.columnDefs]
    this.makeInvoiceGrid.columnDefs = [...this.columnDefs, ...this.makeInvoiceGrid.columnDefs]
    this.jobChargeGrid.columnDefs = [...this.columnDefs, ...this.jobChargeGrid.columnDefs]
    this.chargeChangeGrid.columnDefs = [...this.columnDefs, ...this.chargeChangeGrid.columnDefs]
    this.tempCreditGrid.columnDefs = [...this.columnDefs, ...this.tempCreditGrid.columnDefs]
    this.collectInvoiceGrid.columnDefs = [...this.columnDefs, ...this.collectInvoiceGrid.columnDefs]
    this.companyGrid.columnDefs = [...this.columnDefs, ...this.companyGrid.columnDefs]
    this.contractGrid.columnDefs = [...this.columnDefs, ...this.contractGrid.columnDefs]
    await cache.load(cacheName.USER, cacheName.CONFIG)
    this.user = cache.user
    await this.setLocalCurrency()
  },
  beforeDestroy() {
    this.documentManage.destory()
  },
  activated() {
    const toPath = this.$route.path
    if (toPath === '/ApprovalMatters/ApprovalChecklist' || toPath === '/dashboard') {
      const div = document.getElementById('BillPaymentWorkFlowApplyDialog')
      const approvalNo = this.$store.state.dialogStatus.approvalNo
      if (div && approvalNo) {
        this.$nextTick(() => {
          this.setLineColor(approvalNo)
        })
      }
    }
  },
  methods: {
    openBillPaymentWorkflowApplyDialog() {
      if (!this.billPaymentWorkflowApplyDialogInstance) {
        const office = getObjectByCache(basicCacheKeys.basic_data_Office_All, 'officeId', this.selectRow['officeId'])
        const propsData = {
          visible: true,
          title: this.$t('CargoMsg.Cargo_ReviewTheApprovalProcess'),
          processInfo: this.selectRow,
          billPayment: this.billPayment,
          type: 'approve', // 【付款申请单】已完成的单子，也需要加载按钮【撤销流程】按钮
          dynamics: this.dynamics,
          status: this.status,
          records: this.approvalCommentsRecords,
          lastProcessNode: this.lastProcessNode,
          showWhtBpm: office.whtTaxMode
        }

        this.billPaymentWorkflowApplyDialogInstance = new GlobalDialog(BillPaymentWorkFlowApplyDialog, { propsData })
        const { instance } = this.billPaymentWorkflowApplyDialogInstance

        instance.$on('close', () => {
          this.billPaymentWorkflowApplyDialogInstance.destroySelf()
          this.billPaymentWorkflowApplyDialogInstance = null
        })

        instance.$on('closeAndRefresh', () => {
          this.billPaymentWorkflowApplyDialogInstance.destroySelf()
          this.billPaymentWorkflowApplyDialogInstance = null
          this.applyCloseAndRefresh()
          this.$emit('toQuery')
        })
      }
    },
    onRowDoubleClicked(event) {
      this.detailWrapper(event.data, null)
    },
    toReviewTheProcessRecord(key, uuid, workflowName, documentConfigName, officeId, documentConfigId) {
      this.workflowName = workflowName
      this.documentConfigName = documentConfigName
      this.loading = getLoading('approval-list-grid')
      Promise.all([
        getDocumentProcess({ documentConfigId: documentConfigId, docId: uuid, documentProcessId: key }).then(res => {
          this.processDetail = res.data
        }),
        workflowHistory({ documentProcessId: key }).then(res => {
          this.records = res.data.traces
          this.approvalCommentsRecords = res.data.traces.filter(trace => [7008, 7011, 7012, 7013, 7014].indexOf(trace.actionType) === -1)
        })]
      ).then(res => {
        this.processRecordsDialog.visible = true
      }).finally(() => {
        this.loading.close()
      })
    },
    applyCloseAndRefresh() {
      // this.$emit('reloadCount')
      this.$emit('toQuery')
    },
    toQuery() {
      this.$emit('toQuery')
    },
    getSelections() { // 获取勾选的项目
      return getGridSelected(this.gridOptions)
    },
    detail() {
      const applicationDimension = this.selectRow.applicationDimension
      if (BILL_PAYMENT.code === this.documentConfigId) {
        queryBillPaymentDetail({
          billPaymentUuid: this.docId,
          paging: false,
          requires: 'accountPeriodRemainingDays',
          branchId: this.selectRow['officeId']
        }).then(res => {
          this.billPayment = res.data
          // this.workFlowApplyDialog.visible = true
        })
      } else if (Job_CHARGE.code === this.documentConfigId) {
        this.jobApplyDialog.visible = true
      } else if (MAKE_INVOICE.code === this.documentConfigId) {
        if (APPLICATION_DIMENSION_BILL.code === applicationDimension) {
          // 账单编号 维度（开票单据）
          this.billDialog.visible = true
        } else {
          // 发票ID 维度（开票单据）
          const requestBody = { 'keys': [this.docId] }
          getInvoiceDetails(requestBody).then(async res => {
            console.log('getInvoiceDetails', res)
            this.invoiceProperties.invoices = res.data
            this.invoiceProperties.currentPage = 1
            this.invoiceProperties.totalPage = 1
            this.invoiceProperties.invoice = this.invoiceProperties.invoices[0]
            this.invoiceProperties.interfaceNameEI = String(cache.config.get('EITaxControlInterfaceName'))
            // 增票合并/显示明细
            if (!this.invoiceProperties.invoice) {
              this.$message.warning(this.$t('CargoMsg.Cargo_InvoiceDeleted'))
              return
            }
            if (this.invoiceProperties.invoice.ar && [2, 3].includes(this.invoiceProperties.invoice.invoiceType)) {
              this.invoiceProperties.rbgShowChargeDetail = 'merge'
              for (const invoiceItem of this.invoiceProperties.invoice.invoiceItemList) {
                if (invoiceItem.goodsName.indexOf('\n') > -1) {
                  this.invoiceProperties.rbgShowChargeDetail = 'detail'
                }
              }
            } else if (this.invoiceProperties.invoice.ar && [0, 1, 4].includes(this.invoiceProperties.invoice.invoiceType)) {
              this.invoiceProperties.rbgShowChargeDetail = 'merge'
              if (!StrUtils.isEmpty(this.invoiceProperties.invoice.partAmount) && this.invoiceProperties.invoice.partAmount.indexOf('\n') > -1) {
                this.invoiceProperties.rbgShowChargeDetail = 'detail'
              }
            }
            try {
              await existWorkflowGroup({
                officeId: this.$store.getters.currentOfficeId,
                formSubtype: MAKE_INVOICE_INTERNAL_INVOICE.code
              }).then(async res => {
                this.invoiceProperties.invoiceTriggerBpm = res.data
              })
            } catch (e) {
              // error
            }
            this.invoiceDetailDialog.visible = true
            this.$nextTick(() => {
              this.$refs.makeInvoiceDialog.initBaseData()
            })
          }).finally(() => {
          })
        }
      } else if (COLLECT_INVOICE.code === this.documentConfigId) {
        // 发票ID 维度（收票单据）
        const requestBody = { 'keys': [this.docId] }
        getInvoiceDetails(requestBody).then(async res => {
          this.invoiceProperties.invoices = res.data
          this.invoiceProperties.currentPage = 1
          this.invoiceProperties.totalPage = 1
          this.invoiceProperties.invoice = this.invoiceProperties.invoices[0]
          try {
            this.invoiceProperties.invoiceTriggerBpm = await WorkflowUtil.isBpmEnabled({ documentConfigId: COLLECT_INVOICE.code, officeId: this.$store.getters.currentOfficeId })
          } catch (e) {
            // error
          }
          this.invoiceDetailDialog.visible = true
          this.$nextTick(() => {
            this.$refs.makeInvoiceDialog.initBaseData()
          })
        }).finally(() => {
        })
      } else if (CHARGE_CHANGE.code === this.documentConfigId) {
        getWorkFlowChangeCharge({ changeChargeUuid: this.docId }).then(async res => {
          this.chargeWorkFlowApplyDialog.changeCharge = res.data
          this.chargeWorkFlowApplyDialog.visible = true
        })
      } if (TEMP_CREDIT.code === this.documentConfigId) {
        this.tempCreditApplyDialog.visible = true
      } else if (PARTNER_APPLICATION_FORM.code === this.documentConfigId) {
        getWorkFlowCompany({ uuid: this.docId }).then(async res => {
          this.companyDialog.companyBpm = res.data
          this.companyDialog.visible = true
        })
      } else if (CONTRACT_APPLICATION_FORM.code === this.documentConfigId) {
        getWorkFlowContract({ uuid: this.docId }).then(async res => {
          this.contractDialog.contractBpm = res.data
          this.contractDialog.visible = true
        })
      }
    },
    detailWrapper(data, id) {
      if (data) {
        this.selectRow = data
      } else {
        this.selectRow = this.rowData.filter(row => row.id === id)[0]
      }
      this.$store.commit('APPROVE_DIALOG_SELECT_LINE', this.selectRow.documentProcessNo)
      if (WORKFLOW_DISCARD.code === this.selectRow.state) {
        return
      }
      this.documentConfigId = this.selectRow.documentConfigId
      this.docId = this.selectRow.docId
      this.loading = getLoading('approval-list-grid')
      Promise.all([this.detail(),
        workflowHistory({ documentProcessId: this.selectRow.documentProcessId }).then(res => {
          this.records = res.data.traces
          this.approvalCommentsRecords = res.data.traces.filter(trace => [7008, 7011, 7012, 7013, 7014].indexOf(trace.actionType) === -1)
          this.lastProcessNode = res.data.lastProcessNode
        })]).then(res => {
        if (BILL_PAYMENT.code === this.documentConfigId) {
          this.openBillPaymentWorkflowApplyDialog()
        }
        this.loading.close()
      }).finally(() => {
        this.loading.close()
      })
    },
    pageChange(data) { // 切换发票
      this.invoiceProperties.totalPage = this.invoiceProperties.invoices.length
      if (this.invoiceProperties.currentPage > this.invoiceProperties.totalPage) {
        this.invoiceProperties.currentPage = this.invoiceProperties.totalPage
      }
      if (this.invoiceProperties.currentPage < 1) {
        this.invoiceProperties.currentPage = 1
      }
      if (this.invoiceProperties.totalPage > 0) {
        this.invoiceProperties.invoice = this.invoiceProperties.invoices[this.invoiceProperties.currentPage - 1]

        if (!this.invoiceProperties.invoice) {
          this.$message.warning(this.$t('CargoMsg.Cargo_InvoiceDeleted'))
          return
        }
        // 增票合并/显示明细
        if (this.invoiceProperties.invoice.ar && [2, 3].includes(this.invoiceProperties.invoice.invoiceType)) {
          this.invoiceProperties.rbgShowChargeDetail = 'merge'
          for (const invoiceItem of this.invoiceProperties.invoice.invoiceItemList) {
            if (invoiceItem.goodsName.indexOf('\n') > -1) {
              this.invoiceProperties.rbgShowChargeDetail = 'detail'
            }
          }
        } else if (this.invoiceProperties.invoice.ar && [0, 1, 4].includes(this.invoiceProperties.invoice.invoiceType)) {
          this.invoiceProperties.rbgShowChargeDetail = 'merge'
          if (!StrUtils.isEmpty(this.invoiceProperties.invoice.partAmount) && this.invoiceProperties.invoice.partAmount.indexOf('\n') > -1) {
            this.invoiceProperties.rbgShowChargeDetail = 'detail'
          }
        }
        //
        this.$refs.makeInvoiceDialog.initBaseData()
      }
    },
    async handlePreviewFile(fileObject) {
      this.previewFileData.file = fileObject || null
      this.previewFileData.visible = true
    },
    closePreviewDialog() {
      this.previewFileData.file = null
      this.previewFileData.visible = false
    },
    // 如果审批弹窗有最小化，则进入页面时设置当前审批流水号的行颜色
    setLineColor(approvalNo) {
      if (this.gridOptions.api) {
        let found = false
        this.gridOptions.api.forEachNode((rowNode, index) => {
          if (rowNode.data.documentProcessNo === approvalNo) {
            // 高亮行
            this.gridOptions.api.setFocusedCell(rowNode.rowIndex, 'documentProcessNo')
            this.gridOptions.api.redrawRows({ rowNodes: [rowNode] })
            found = true
          }
        })
      }
    },
    // 排序事件处理
    onSortChanged(event) {
      this.highlightRow()
    },
    async setLocalCurrency() {
      this.localCurrency = RateUtil.localCurrencyByOffice()
      if (this.localCurrency !== 'RMB') {
        setTimeout(() => { this.reCalc = false }, 100)
        setTimeout(() => { this.reCalc = true }, 100)
      }
    },
    toRefreshSelectedCountChargeGrid(event) {
      const selectedRows = event.api.getSelectedRows()
      this.$emit('changeSelected', selectedRows)
      this.filterChange()
    },
    filterChange() {
      this.selections = getGridSelected(this.billPaymentGrid.gridOptions)
      this.dataShow = true
      if (this.selections.length > 0) {
        this.once.excute(this.refreshSelectedCountChargeGrid, [0, this.selections], 200)
      } else {
        this.$nextTick(() => {
          const hasDisplay = []
          this.billPaymentGrid.gridOptions.api.forEachNode(node => {
            if (node.displayed) {
              hasDisplay.push(node.data)
            }
          })
          if (hasDisplay.length > 0) {
            if (hasDisplay.length == this.rowData.length) {
              this.once.excute(this.refreshSelectedCountChargeGrid, [], 200)
            }
            if (hasDisplay.length < this.rowData.length) {
              this.once.excute(this.refreshSelectedCountChargeGrid, [], 200)
            }
          } else {
            this.dataShow = false
            this.once.excute(this.refreshSelectedCountChargeGrid, [], 200)
          }
        })
      }
    },
    refreshSelectedCountChargeGrid(arg, selections) {
      if (arg === 0) {
        this.totalAmountToCurrencyBillPaymentGrid.selectionCountLabel = this.$t('Clearing.Selected') + selections.length + '：'
        this.totalAmountToCurrencyBillPaymentGrid.dataProvider = selections
        this.totalAmountToCurrencyBillPaymentGrid.selectedCount = selections.length
      } else if (arg === 1) {
        this.totalAmountToCurrencyBillPaymentGrid.selectionCountLabel = ''
        this.totalAmountToCurrencyBillPaymentGrid.dataProvider = selections
        this.totalAmountToCurrencyBillPaymentGrid.selectedCount = 0
      } else {
        this.totalAmountToCurrencyBillPaymentGrid.selectionCountLabel = ''
        this.totalAmountToCurrencyBillPaymentGrid.dataProvider = this.rowData
        this.totalAmountToCurrencyBillPaymentGrid.selectedCount = 0
      }
    },
    rowDataChange(data) {
      if (data && data.length > 0) {
        this.totalAmountToCurrencyBillPaymentGrid.selectionCountLabel = ''
        this.totalAmountToCurrencyBillPaymentGrid.dataProvider = this.rowData
        this.totalAmountToCurrencyBillPaymentGrid.selectedCount = 0
      } else {
        this.totalAmountToCurrencyBillPaymentGrid.selectionCountLabel = ''
        this.totalAmountToCurrencyBillPaymentGrid.dataProvider = []
        this.totalAmountToCurrencyBillPaymentGrid.selectedCount = 0
      }
    },
    // 高亮行的逻辑
    highlightRow() {
      const approvalNo = this.$store.state.dialogStatus.approvalNo
      if (this.gridOptions.api && approvalNo) {
        this.gridOptions.api.forEachNode((rowNode) => {
          if (rowNode.data.documentProcessNo === approvalNo) {
            // 高亮行
            this.gridOptions.api.setFocusedCell(rowNode.rowIndex, 'documentProcessNo')
            this.gridOptions.api.redrawRows({ rowNodes: [rowNode] })
          }
        })
      }
    }
  }
}
</script>

<style lang="scss">
.approval-list-grid {
  .make-invoice-dialog {
    #tab-makeInvoice.el-tabs__item.is-top.is-active {
      color: #FFFFFF;
    }
    #tab-chargeDetails.el-tabs__item.is-top.is-active {
      color: #FFFFFF;
    }
    #tab-fileAttachment.el-tabs__item.is-top.is-active {
      color: #FFFFFF;
    }
    #tab-makeInvoice.el-tabs__item.is-top {
      color: black;
    }
    #tab-chargeDetails.el-tabs__item.is-top {
      color: black;
    }
    #tab-fileAttachment.el-tabs__item.is-top {
      color: black;
    }
  }
}
</style>
